<template>
	<div>
		<el-button id= "add" type="primary" size="medium" round @click = "dialogFormVisible = true">添加公司</el-button>
		<el-dialog title="添加公司" :visible.sync="dialogFormVisible">
		  <el-form :model="form" :rules="rules" ref="ruleForm" status-icon>
		    <el-form-item label="公司名称" :label-width="formLabelWidth" prop="dw">
		      <el-input v-model="form.dw" auto-complete="off"></el-input>
		    </el-form-item>
		    <el-form-item label="管理员账号" :label-width="formLabelWidth" prop="name">
		      <el-input v-model="form.name" auto-complete="off"></el-input>
		    </el-form-item>
		    <el-form-item label="学员人数上限" :label-width="formLabelWidth" prop="max">
		    	<el-input-number size="small" v-model="form.max" controls-position="right" :min="0" :max="9999"></el-input-number>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="resetForm('ruleForm');">取 消</el-button>
		    <el-button type="primary" @click="submitForm('ruleForm');">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
	    data() {
	      return {
	        dialogFormVisible: false,
	        form: {
	        	id:0,
	        	name: '',
	        	dw: '',
	        	max:1
	        },
	        formLabelWidth: '120px',
			rules:{
	          dw: [
	            { required: true, message: '请填写公司名称', trigger: 'blur' },
	          ],
	          name: [
	            { required: true, message: '请填写管理员账号', trigger: 'blur' },
	          ]
			}
	      };
	    },
	    methods: {
			submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			  	this.$message({showClose: true,message: '提交中……'});
			  	this.dialogFormVisible = false;
			  	this.addAdmin();
			  } else {
			    this.$message({showClose: true,message: '单位名称未填写',type: 'warning'});
			    return false;
			  }
			});
			},
			resetForm(formName) {
				this.dialogFormVisible = false;
				this.$refs[formName].resetFields();
			},
			addAdmin(){
				var params = new URLSearchParams();
				params.append('token', 'zqgU1wqtfzcZRAniU');
		        params.append('admin', this.$store.getters.name);
		        params.append('my', this.$store.getters.token);
				params.append('name', this.form.name);
				params.append('dw', this.form.dw);
				params.append('max', this.form.max);
				this.resetForm('ruleForm');
				this.$ajax.post("/apis/admin.php",params).then((ret) => {
			    	// console.log(ret)
			    	if (ret.data == true) {
					    this.$emit("rf_admin");
					    this.$message({showClose: true,message: '已添加',type: 'success'});
			    	}else this.$notify.error({title: '错误',message: ret.data});
				}).catch(err=>{
				    this.$notify.error({title: '错误',message: '网络异常'});
				});
			}
	    }
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Adda.vue